import api from 'ApiConfig';

const passwordService = {
  getAllPasswordResetRequests: async () => {
    return api.get('/admin/get-all-password-reset-requests');
  },
  // updatePasswordResetRequests: async (payload) => {
  //   const {
  //     name: accountantName,
  //     email: accountantEmail,
  //     password: accountantPassword,
  //     _id: accountantId,
  //   } = payload;
  //   const updatedPayload = {
  //     accountantName,
  //     accountantEmail,
  //     accountantPassword,
  //     accountantId,
  //   };
  //   return api.post('/admin/update-password-reset-requests', updatedPayload);
  // },
  updatePasswordResetRequests: async (data) => {
    // console.log(userId, password,"userId, password")
    return api.post('/admin/update-password-reset-requests', data);
  },
};
export default passwordService;
